import { randomUUID } from 'node:crypto';
import {
  wixCliFileFolderCreatedRenamedDeleted,
  wixCliCliMessageDisplayed,
  wixCliCodeHasBeenChanged,
  wixCliUserResponseToCliMessage,
  wixCliReadyForReloadAfterCodeChange,
} from '@wix/bi-logger-wix-cli/v2';
import type { BiLogger } from '@wix/cli-telemetry';
import type { ProjectModel } from './model.js';

export const sitesBiEvents = (biLogger: BiLogger) => ({
  file: ({
    model,
    action,
    path,
    sectionName,
    oldPath,
  }: {
    model: ProjectModel;
    action: 'create' | 'update' | 'delete';
    path: string;
    sectionName: string;
    oldPath: string;
  }) => {
    void biLogger.report(
      wixCliFileFolderCreatedRenamedDeleted({
        action,
        path,
        sectionName,
        oldPath,
        siteRevision: Number(model.revision),
      })
    );
  },
  codeChanged: (model: ProjectModel, fileName: string) => {
    void biLogger.report(
      wixCliCodeHasBeenChanged({
        fileName,
        siteRevision: Number(model.revision),
      })
    );
  },
  readyForReloadAfterCodeChanged: (model: ProjectModel) => {
    void biLogger.report(
      wixCliReadyForReloadAfterCodeChange({
        siteRevision: Number(model.revision),
      })
    );
  },
  messageDisplayed: ({
    message,
    model,
  }: {
    message: string;
    model: ProjectModel;
  }) => {
    void biLogger.report(
      wixCliCliMessageDisplayed({
        message,
        messageId: randomUUID(),
        siteRevision: Number(model.revision),
      })
    );
  },
  userResponse: ({
    model,
    action,
    message,
  }: {
    model: ProjectModel;
    action: 'Browser opened';
    message: string;
  }) => {
    void biLogger.report(
      wixCliUserResponseToCliMessage({
        action,
        message,
        messageId: randomUUID(),
        siteRevision: Number(model.revision),
      })
    );
  },
});

export type SitesBiEvents = ReturnType<typeof sitesBiEvents>;
